// @ts-nocheck
import { toastTypes } from '../../enums';
import { createOAuthIntegrationStore } from './_shared';

export default createOAuthIntegrationStore({
  partnerKey: 'Salesforce',
  defaultConfigs: { enabled: false },
  toastKeys: { update: toastTypes.salesForceUpdateConfigs, tokens: toastTypes.salesForceGetTokens },
  successMessages: { tokens: 'Salesforce integration successful.' },
});
